import { render, staticRenderFns } from "./nameModal.vue?vue&type=template&id=bbf2d3e2&"
import script from "./nameModal.vue?vue&type=script&lang=js&"
export * from "./nameModal.vue?vue&type=script&lang=js&"
import style0 from "./nameModal.vue?vue&type=style&index=0&id=bbf2d3e2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports